import { render, staticRenderFns } from "./FeatureToast.vue?vue&type=template&id=37966886&scoped=true&"
import script from "./FeatureToast.vue?vue&type=script&lang=js&"
export * from "./FeatureToast.vue?vue&type=script&lang=js&"
import style0 from "./FeatureToast.vue?vue&type=style&index=0&id=37966886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37966886",
  null
  
)

export default component.exports